import { Navigate } from 'react-router-dom'
import { useProjectId } from '../../../hooks/useProjectId'
import { TranslationsPage } from '../MultiMarket/TranslationsPage'
import { WaveFlowBreadcrumb } from './WaveFlowBreadcrumb'
import { useWaveId } from './useWaveId'
import { useWaves } from './useWaves'

/** The translations editor scoped to this wave's questionnaire and markets. */
export const WaveTranslationsPage = () => {
  const projectId = useProjectId()
  const waveId = useWaveId()
  const { waves, loading } = useWaves(projectId)
  const wave = waves.find((candidate) => candidate.waveId === waveId)

  if (loading) {
    return null
  }

  if (!wave) {
    return <Navigate to={`/project/${projectId}`} replace />
  }

  return (
    <TranslationsPage
      breadcrumb={<WaveFlowBreadcrumb activeStep="Translations" />}
      markets={wave.surveys}
    />
  )
}
